<div class="mb-3" [class.has-error]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
  </label>

  <div>

  <input [cpDisableInput]="true" [cpOKButton]="true" [cpOKButtonClass]="'btn btn-xs btn-primary'" (colorPickerChange)="changeColor($event)" readonly="readonly" class="color-picker-input" [formlyAttributes]="field" [formControl]="formControl" [(colorPicker)]="model.color" [style.background]="model.color"/>


  </div>
  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
